
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Panel from 'vux/src/components/panel/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import headers from '../components/headers'
let img_list = [
{
url: 'javascript:',
img: 'src/assets/images/MCYKFPT.png',
title: ''
},{
url: 'javascript:',
img: 'src/assets/images/GYAPP.png',
title: ''
},{
url: 'javascript:',
img: 'src/assets/images/HYZX.png',
title: ''
}
]
let news_list1 = [
{
src: 'src/assets/images/JJSCGL.jpg',
desc: '第十一期：ERP与MES结合的优点',
name: '第十一期资讯'
},{
src: 'src/assets/images/JJSCGL.jpg',
desc: '第十期：企业生产管理过程对MES系统的需求分析',
name: '第十期资讯'
},{
src: 'src/assets/images/JJSCGL.jpg',
desc: '第九期：MES系统九大功能助力企业生产变革！',
name: '第九期资讯'
}
]
let partner_list = [
{
src: 'src/assets/partner/1.jpg',
name: '长虹'
},{
src: 'src/assets/partner/2.jpg',
name: '海尔'
},{
src: 'src/assets/partner/3.jpg',
name: '华为'
},{
src: 'src/assets/partner/4.jpg',
name: '康佳'
},{
src: 'src/assets/partner/5.jpg',
name: '飞毛腿'
},{
src: 'src/assets/partner/6.jpg',
name: 'ABB'
},{
src: 'src/assets/partner/7.jpg',
name: 'TPV'
},{
src: 'src/assets/partner/8.jpg',
name: '美菱'
},{
src: 'src/assets/partner/9.jpg',
name: '明美'
},{
src: 'src/assets/partner/10.jpg',
name: '欣旺达'
},{
src: 'src/assets/partner/11.jpg',
name: '星网锐捷'
},{
src: 'src/assets/partner/12.jpg',
name: '网龙'
},{
src: 'src/assets/partner/13.jpg',
name: '华意'
},{
src: 'src/assets/partner/14.jpg',
name: 'DNXC'
},{
src: 'src/assets/partner/15.jpg',
name: '明美'
}
]
let _hmt = _hmt || [];
export default {
components: {
Swiper,
SwiperItem,
Panel,
Flexbox,
FlexboxItem,
headers
},
created(){

},
mounted(){
this.footjs();
},
methods:{
drop_active(){
this.dorp = !this.dorp;
},
drop_active1(){
this.dorp1 = !this.dorp1;
},
drop_active2(){
this.dorp2 = !this.dorp2;
},
showMore(){
this.$vux.alert.show({
title: 'showMore'
});
},
footjs(){
let hm = document.createElement("script");
hm.src = "https://hm.baidu.com/hm.js?22c1001a656acb63c91abffeeb5e9419";
let s = document.getElementsByTagName("script")[0];
s.parentNode.insertBefore(hm, s);
}
},
data(){
return{
swiper_list: img_list,
swiper_index: 0,
news_list: news_list1,
type: '1',
items: partner_list,
dorp: false,
dorp1: false,
dorp2: false,
}
}
}



// WEBPACK FOOTER //
// ./src/views/index.vue